import KubernetesImg from "public/kubernetes/Kubernetes.png";

export const WHY_ONEMIND_CONSTANTS = {
  title: "Use Cases Of Kubernetes",
  points: [
    {
      label: "Platform Teams",
      text: "Spin up secure, multi-tenant clusters for internal services.",
    },
    {
      label: "Microservices at Scale",
      text: "Automatically scale workloads without managing infrastructure.",
    },
    {
      label: "Dev/Test Environments",
      text: "Enable developers with namespace-isolated access for testing and staging.",
    },
    {
      label: "Hybrid/Multi-Cloud Orchestration",
      text: "Run Kubernetes clusters seamlessly across cloud and on-premises infrastructure.",
    },
    {
      label: "SaaS Products",
      text: "Deploy and update distributed services reliably using GitOps pipelines.",
    },
  ],
  image: KubernetesImg,
};
